import { fromJS } from "immutable"
import {
  GET_DIMENSIONS_OUTCOMES_WATCHER,
  GET_DIMENSIONS_OUTCOMES_SUCCESS,
  GET_DIMENSIONS_OUTCOMES_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: true,
  dimensionsOutcomes: [],
})

function widgetListOutcomesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DIMENSIONS_OUTCOMES_WATCHER:
      return state.set("isLoading", true)

    case GET_DIMENSIONS_OUTCOMES_SUCCESS:
      return state
        .set("isLoading", false)
        .set("dimensionsOutcomes", action.payload)

    case GET_DIMENSIONS_OUTCOMES_FAILED:
      return state.set("isLoading", false).set("dimensionsOutcomes", [])

    default:
      return state
  }
}

export default widgetListOutcomesReducer
